module.exports = __webpack_public_path__ + "img/control_de_calidad_3-4_2304.6800141c.jpg";